export const STEPS = {
  DETAILS: 'DETAILS',
  REVIEW: 'REVIEW',
  UNIT_ENTRY: 'UNIT_ENTRY',
  PROPERTY_DETAILS: 'PROPERTY_DETAILS',
  SUCCESS: 'SUCCESS',
} as const;

export type Step = (typeof STEPS)[keyof typeof STEPS];
